import * as yup from 'yup';
import { BusinessUser, GyminifyEmployee } from "../../../service/model/user.model";
import { UserType } from "../../../shared/enums";
import { Member } from "../../../service/model/member.model";
import BusinessUserForm from "./business-user-form";
import AdminUserForm from "./admin-user-form";
import MemberUserForm from "./member-user-form";
import Dialog from '@mui/material/Dialog';
import { Box, DialogTitle, Paper } from '@mui/material';
import FormCloseButton from '../../../components/form-controls/form-close-button';

interface UserFormProps {
    readonly userType: UserType
    // readonly authUser: User | null
    readonly user?: BusinessUser | Member | GyminifyEmployee
    readonly isProfile?: boolean
    readonly editable?: boolean
    readonly onClose: () => void
    // readonly onSubmit: (data: User) => void
}

const validationSchema = yup.object().shape({
    username: yup.string().required("Username is required"),
    roles: yup.string().required("Role is required"),
    firstName: yup.string().required("First name is required"),
    lastName: yup.string().required("Last name is required"),
    email: yup.string().email("Not a valid email"),
    // gender: yup.string().required("Gender is required"),
    dateOfBirth: yup.string(),
    contact: yup.string(),
    address: yup.string(),
});

const style = {
    // position: 'absolute' as 'absolute',
    // top: '50%',
    // left: '50%',
    // transform: 'translate(-50%, -50%)',
    // width: '100%',
    // bgcolor: 'background.paper',
    // border: '2px solid #000',
    // boxShadow: 24,
    p: 2,
};

export type FormValues = yup.InferType<typeof validationSchema>;

const UserForm: React.FC<UserFormProps> = (props) => {

    return (
        <>
            {props.isProfile ?
                <Paper sx={{ p: 2 }}>
                    {props.userType === UserType.BUSINESS_USER && <BusinessUserForm user={props.user as BusinessUser} onClose={props.onClose} />}
                    {props.userType === UserType.GYMINIFY && <AdminUserForm user={props.user as GyminifyEmployee} onClose={props.onClose} />}
                    {props.userType === UserType.MEMBER && <MemberUserForm user={props.user as Member} onClose={props.onClose} />}
                </Paper>
                : <Dialog open={true} onClose={props.onClose} sx={style} fullWidth maxWidth='md'>
                    <DialogTitle sx={{ paddingBottom: 0 }}>User Details</DialogTitle>
                    <Box sx={style}>
                        <>
                            <FormCloseButton onClose={props.onClose} />
                            {props.userType === UserType.BUSINESS_USER && <BusinessUserForm user={props.user as BusinessUser} onClose={props.onClose} />}
                            {props.userType === UserType.GYMINIFY && <AdminUserForm user={props.user as GyminifyEmployee} onClose={props.onClose} />}
                            {props.userType === UserType.MEMBER && <MemberUserForm user={props.user as Member} onClose={props.onClose} />}
                        </>
                    </Box>
                </Dialog>}
        </>
    );
}

export default UserForm;